import baseRequest from './baseRequest';

export function create(params) {
  return baseRequest.post('/api/public/borrowers', params);
}
